import signals from '../lib/signals.js';

export class StudentAttendanceModel {
	constructor(student, attendance) {
		this.Student = student;
		this.Attendance = attendance;

		this.changed = new signals.Signal();
	}
	setAttendance(at, src=null) {
		if (at.Id == this.Attendance.Id) {
			return;
		}
		this.Attendance = at;
		this.changed.dispatch(this.student, this.Attendance, src);
	}
	isPresent() {
		return this.Attendance.Id > 0;
	}
}